import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearUser } from "../redux/userSlice";
import { toast } from "react-toastify";

const InactiveAccountModal = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();


   const handleLogout = () => {
      dispatch(clearUser());
      toast.success("Logged out successfully");
      navigate("/");
    };
  

  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = originalOverflow; };
  }, []);

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70 p-4">
      <div className="w-full max-w-[560px] overflow-hidden rounded-[20px] border border-white/10 bg-white">

        {/* Red header */}
        <div className="flex items-center gap-4 bg-red-500 px-7 py-6">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-white/30 bg-white/15">
            <svg className="h-5 w-5 text-white" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          </div>
          <div>
            <p className="text-[11px] font-medium uppercase tracking-[0.16em] text-white/70">Account status</p>
            <h1 className="mt-1 text-[22px] font-medium text-white">Access Restricted</h1>
          </div>
        </div>

        {/* Body */}
        <div className="flex flex-col gap-4 px-7 py-6">
          <p className="text-sm leading-7 text-gray-600">
            Your account has been <span className="font-medium text-red-500">deactivated</span> and can no longer access this platform. If you believe this is an error, please contact support immediately.
          </p>

          {/* Contact card */}
          <div className="rounded-r-[10px] border border-red-100 bg-red-50 py-4 pl-5 pr-5" style={{ borderLeftWidth: 3, borderLeftColor: "#dc2626" }}>
            <p className="mb-1.5 text-[11px] font-medium uppercase tracking-widest text-black">Contact support</p>
            <a href="mailto:support@txtconnect.com" className="flex items-center gap-1.5 text-sm font-medium text-red-600 no-underline hover:text-red-500">
              <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" />
              </svg>
              support@txtconnect.com
            </a>
          </div>

          {/* Important notice */}
          {/* <div className="rounded-r-[10px] border border-red-100 bg-red-50 py-4 pl-5 pr-5" style={{ borderLeftWidth: 3, borderLeftColor: "#dc2626" }}>
            <p className="mb-1 text-[13px] font-medium text-gray-800">Important</p>
            <p className="text-[13px] leading-relaxed text-gray-500">This screen blocks all platform navigation until your account is reactivated by an administrator.</p>
          </div> */}

          <a href="mailto:support@txtconnect.com" className="mt-1 block w-full rounded-[10px] bg-red-600 py-3.5 text-center text-sm font-medium text-white no-underline hover:bg-red-700 active:scale-[0.98]">
            Contact Support
          </a>

        {/* <button className=" mt-1 block w-full  rounded-[10px] text-red-500  py-3.5 text-center text-sm font-medium  no-underline hover:bg-red-100 hover:text-red-400 active:scale-[0.98]" >
            Logout
        </button> */}
        <button onClick={handleLogout} className="mt-1 block w-full rounded-[10px] bg-white border border-red-300 text-red-500 py-3.5 text-center text-sm font-medium no-underline hover:bg-red-100 hover:text-red-400 active:scale-[0.98]">
 Cancel
</button>

          {/* <p className="text-center text-xs text-gray-400">
            Need urgent help? Call <span className="text-gray-700">+1 800 000 0000</span>
          </p> */}
        </div>
      </div>
    </div>
  );
};

export default InactiveAccountModal;